import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // ogni volta che cambia il path, torna in cima
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null; // non renderizza nulla
}
